import React, { Component } from 'react'
import { connect } from "react-redux"
import { AxiosResponse } from 'axios';
import trans from "trans"

import {
    css,
    Spinner,
    Select,
} from "@bdfx/mergado-ui-kit"

import { Item } from "@bdfx/mergado-ui-kit/lib/components/Form/Autocomplete";

import { getMergadoElements } from 'app/helpers/api';
import { MergadoElementsType } from 'products/types';
import { ReduxList } from '../types/app-types';
import { setElementsToStore } from 'actions';
import { setIsLoadingElementsToStore } from 'actions/index';

interface Props {
    elements: ReduxList<MergadoElementsType>
    setElementsToStore: typeof setElementsToStore,
    setIsLoadingElementsToStore: typeof setIsLoadingElementsToStore,
    value: string
    handleChange: Function
    onClear?: Function
    error?: string
    invalid?: boolean
}

class MergadoElementSelect extends Component<Props> {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (!this.props.elements.isLoaded && !this.props.elements.isLoading) {
            this.props.setIsLoadingElementsToStore(true)
            getMergadoElements(true, true)
                .then((response: AxiosResponse<MergadoElementsType>) => {
                    this.props.setElementsToStore(response.data)
                })
                .catch(error => {
                    console.debug('error while loading elements', error)
                    this.props.setIsLoadingElementsToStore(false)
                })
        }
    }

    onSearch = (phrase, option) => typeof option.name === "string" ? option.name.toLowerCase().indexOf(phrase.toLowerCase()) !== -1 : true

    render() {
        const { value, elements } = this.props

        if (!elements.isLoaded || elements.isLoading) {
            return <Spinner type={'bubbles'} />
        }

        const options: Item[] = elements.data.map((o: string | string[]) => {
            const stringValue = typeof o === "string" ? o : JSON.stringify(o)

            return {
                label: stringValue,
                value: stringValue
            }
        })

        return (
            <React.Fragment>
                <StyledSelect
                    value={value}
                    multiple={false}
                    options={options}
                    search={true}
                    searchPlaceholder={trans('search')}
                    onSearch={this.onSearch}
                    onChange={this.props.handleChange}
                    onClear={this.props.onClear}
                    error={this.props.error}
                    invalid={this.props.invalid}
                    closeOnChange={true}
                    floatStyles={{
                        minWidth: '350px !important',
                    }}
                    className='mergado-element-select'
                />
            </React.Fragment>
        )
    }
}

const StyledSelect = css(Select)({
    ' input.react-select-item-search': {
        width: '100%',
        lineHeight: '25px',
    },
})

function mapStateToProps(state) {
    return {
        elements: state.elements,
    }
}

export default connect(mapStateToProps, {
    setElementsToStore,
    setIsLoadingElementsToStore,
})(MergadoElementSelect)
